// Socials — TikTok and Facebook videos featuring Joe Kress
// Uses official embed methods (TikTok blockquote embed + Facebook video plugin iframe).
// To add a new video: append an object to VIDEOS with { platform, url, title }
// Or use the built-in admin at /socials/admin to auto-generate the snippet.

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/1WCHx3EJiz/',
  tiktok: 'https://www.tiktok.com/@joekress', // update if the exact handle differs
};

// Newest videos first. Each item must have:
// - platform: 'tiktok' | 'facebook'
// - url: full public URL to the post
// - title (optional): a short caption/description shown on the card
// - date (optional): free-text publication date
export const VIDEOS = [
  // Example structure (uncomment and replace URL to test):
  // {
  //   platform: 'tiktok',
  //   url: 'https://www.tiktok.com/@joekress/video/1234567890123456789',
  //   title: 'Choose Your Future',
  // },
  // {
  //   platform: 'facebook',
  //   url: 'https://www.facebook.com/joekress/videos/1234567890',
  //   title: 'Real People. Real Stories.',
  // },
];
